import '../../../../core/components/app-root/AppRoot.css';
import '../../DataTable.css';
import '../../components/Alignment.css';
import '../ColumnOrder/ColumnOrder.css';
import '../Thresholds/Thresholds.css';
import '../../components/DataTableHeaderCell.css';
import './DataTableGanttChartHeader.css';
export var ganttChartHeader = '_10y95u40-3-5-0';